// /**
//  * Users - edit
//  */

// React
import React from 'react';

// UI
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {Grid} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiAccountOutline,
  mdiCellphone,
  mdiEmailOutline,
  mdiAccountKeyOutline,
} from '@mdi/js';

// Helper
import {translateUserRoles, formaterPhoneNumber} from '../../../utils/helpers';

// Type
type Props = {
  data: any;
};

// Style
// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        // margin: theme.spacing(3),
        // fontFamily: 'sans-font',
      },
    },
    paper: {
      marginTop: theme.spacing(4),
      padding: theme.spacing(4),
      border: '1px solid #ddd',
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      '& > *': {
        margin: theme.spacing(0, 1),
      },
    },
  })
);

export default function Detail(props: Props) {
  const classes = useStyles();

  return (
    <Grid container spacing={4}>
      <Grid item xs={6}>
        <div className={classes.item}>
          <Icon path={mdiAccountOutline} size={1} />
          {`نام کاربر:  `}
          <span>{props.data.name}</span>
        </div>
      </Grid>

      <Grid item xs={6}>
        <div className={classes.item}>
          <Icon path={mdiAccountKeyOutline} size={1} />
          {`کد کاربر:  `}
          <span>{props.data.id}</span>
        </div>
      </Grid>

      <Grid item xs={6}>
        <div className={classes.item}>
          <Icon path={mdiCellphone} size={1} />
          {`شماره تماس:  `}
          <span>{formaterPhoneNumber(props.data.phoneNumber)}</span>
        </div>
      </Grid>

      <Grid item xs={6}>
        <div className={classes.item}>
          <Icon path={mdiEmailOutline} size={1} />
          {`ایمیل کاربر:`}
          <span>{props.data.emailAddress}</span>
        </div>
      </Grid>

      <Grid item xs={6}>
        <div className={classes.item}>
          <Icon path={mdiAccountOutline} size={1} />
          {`نقش کاربر:  `}
          <span>{translateUserRoles(props.data.role)}</span>
        </div>
      </Grid>
    </Grid>
  );
}
